import { Dispatch, SetStateAction, useContext } from 'react';
import { widgetDataContext } from '../widgetDataContext';

type ReturnType<T> = {
  data: T;
  setData: Dispatch<SetStateAction<T>>;
};

export const useWidgetData = <T>(): ReturnType<T> => {
  const { data, setData } = useContext(widgetDataContext);

  return {
    data: data as T,
    setData: setData as Dispatch<SetStateAction<T>>,
  };
};
